import { getGrowthBookConfigLoader } from '@doxyme/config';

export const AUTH_SESSION_TELEMETRY_FLAG =
  'feat_prod_7547_auth_session_telemetry' as const;

export const getIsAuthSessionTelemetryEnabled = (): boolean =>
  getGrowthBookConfigLoader().getOptional(AUTH_SESSION_TELEMETRY_FLAG) === true;
